module.exports = __webpack_public_path__ + "img/sld_scb_3_t1_b1_dark.482cd8e0.svg";